module.exports = __webpack_public_path__ + "img/login-v4.d7614621.svg";